import { SvgIcon, SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import clsx from 'clsx'
import React from 'react'

const InsertUOMIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
    props: any
) => (
    <SvgIcon
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={clsx('InsertUOMIcon', props.className)}
    >
        <path
            d="M16.4106 0V8.72727H0.410645V0H16.4106ZM14.9561 1.45455H12.7743V3.27273H11.3197V1.45455H9.13792V4.36364H7.68337V1.45455H5.50155V3.27273H4.04701V1.45455H1.86519V7.27273H14.9561V1.45455Z"
            fill="#314959"
        />
    </SvgIcon>
)

export default InsertUOMIcon
